// extracted by mini-css-extract-plugin
module.exports = {"banner":"docs-banner_banner__Htn4j","green":"docs-banner_green___Uh6v","red":"docs-banner_red__rOSZy","purple":"docs-banner_purple__zVrhd","blue":"docs-banner_blue__LF8Qd"};